module.exports = __webpack_public_path__ + "media/folder.6cbabf74.svg";